import { TableColumn, TableColumnType } from '@thehubz/client/core';
import { AssetMetadata } from '@thehubz/shared/model';
import { getDriveListSEAT, getSpecialModelListSEAT, getTrimListSEAT } from '../customer-metadata-config';
import { CHANNELS, MEDIATYPE } from './seat-form-fields';

export class SeatTableColumnData {
  /* Default table column configurations */
  static TABLE_DEFAULT_COLUMNS: TableColumn[] = [
    {
      sequence: 1,
      columnDef: 'checked',
      header: $localize`Checkbox`,
      type: TableColumnType.checkbox,
      class: 'w-[auto] grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
      sticky: true,
    },
    {
      sequence: 2,
      columnDef: 'previewUrl',
      header: $localize`Asset`,
      type: TableColumnType.assetPreview,
      class: 'w-[13vw] min-w-[9rem] pl-4 grow-0',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 3,
      columnDef: 'name',
      header: $localize`Name`,
      class: 'w-[30rem] pl-4',
      filter: false,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 4,
      columnDef: 'assetType',
      header: $localize`:asset type:Type`,
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 7,
      columnDef: AssetMetadata.General.TAGS,
      type: TableColumnType.tags,
      header: $localize`Tags`,
      class: 'w-[12%] min-w-[12rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 5,
      columnDef: 'brandMarke',
      header: 'Marke',
      class: 'w-[9%] min-w-[9rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 6,
      columnDef: 'brandModel',
      header: 'Model',
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 8,
      columnDef: 'status',
      header: $localize`Status`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 9,
      columnDef: 'createdAt',
      type: TableColumnType.date,
      header: $localize`Created at`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 10,
      columnDef: 'createdBy',
      type: TableColumnType.createdByUserIcon,
      header: $localize`Created by`,
      class: 'w-[8%] min-w-[6rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
    {
      sequence: 11,
      columnDef: 'expiryDate',
      type: TableColumnType.date,
      header: $localize`Expiry date`,
      class: 'w-[8%] min-w-[8rem]',
      filter: true,
      filterSelected: 0,
      visible: true,
      columnType: 'default',
    },
  ];
  /* Additional columns configurations */
  static ADD_COLUMNS: TableColumn[] = [
    {
      sequence: 4,
      columnDef: 'customFields',
      header: 'Sondermodell',
      showValue: 'specialModel',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: getSpecialModelListSEAT(),
    },
    {
      sequence: 4,
      columnDef: 'customFields',
      header: 'Medienart',
      showValue: 'mediaType',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: [...MEDIATYPE[0]['lists'], ...MEDIATYPE[1]['lists']],
    },
    {
      sequence: 4,
      columnDef: 'customFields',
      header: 'Kanäle',
      showValue: 'channels',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: CHANNELS,
    },
    {
      sequence: 4,
      columnDef: 'customFields',
      header: 'Modelljahr',
      showValue: 'modelYear',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
    },
    {
      sequence: 4,
      columnDef: 'customFields',
      header: 'Trim',
      showValue: 'trim',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: getTrimListSEAT(),
    },
    {
      sequence: 4,
      columnDef: 'customFields',
      header: 'Antrieb',
      showValue: 'drive',
      class: 'w-[10%] min-w-[10rem]',
      filter: true,
      filterSelected: 0,
      visible: false,
      columnType: 'additional',
      options: getDriveListSEAT(),
    },
  ];
}
